<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row">
          <div class="header-action">
            <!-- New Button -->
            <app-button data-testid="new-CheckPoint-button" variant="filled" (click)="onNewCheckpointClick()"
              [disabled]="forms().length === 0" *hasPermission="'asset.create'">
              <app-icon name="plus" /> {{ 'checkpoint.list.new' | translate }}
            </app-button>
          </div>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      @if (forms().length === 0) {
      <div class="empty-state">
        <app-icon name="alert-circle" [size]="48" color="var(--fg-danger)" />
        <h3>{{ 'checkpoint.list.noInteractionTypes.title' | translate }}</h3>
        <p>{{ 'checkpoint.list.noInteractionTypes.description' | translate }}</p>
        <app-button variant="filled" routerLink="/forms/new">
          <app-icon name="plus" />
          {{ 'checkpoint.list.noInteractionTypes.createButton' | translate }}
        </app-button>
      </div>
      }
      @else {
      <!-- Entity List Selector with custom row template for assets -->
      <app-entity-list-selector entityType="checkPoints" mode="single" [showActions]="false"
        [rowTemplate]="checkPointRowTemplate" />

      <!-- Custom Row Template for CheckPoint entities -->
      <ng-template #checkPointRowTemplate let-checkPoint>
        <div class="checkPoint-card m-xs">
          <div class="checkPoint-item">
            <div class="checkPoint-info" (click)="editCheckPoint(checkPoint)"
              (keydown.enter)="editCheckPoint(checkPoint)" (keydown.space)="editCheckPoint(checkPoint)" role="button"
              tabindex="0">
              <h3 class="clickable">{{ checkPoint.name }}
                @if (getInstanceCount(checkPoint.id); as count) {
                <span class="instance-count-badge" data-testid="instance-count-badge">×{{ count }}</span>
                }
              </h3>
              <div class="qr-buttons">
                <app-button variant="outlined" size="sm" (click)="showCheckPointQrCode(checkPoint, $event)"
                  data-testid="qr-button-asset">
                  <app-icon name="qr-code" />
                  {{ 'checkpoint.list.qr.allInteractions' | translate }}
                </app-button>

                @for (form of getCheckPointForms(checkPoint.id); track form.id) {
                <app-button variant="outlined" size="sm" class="clickable"
                  (click)="showFormView(checkPoint, form, $event)" [attr.data-testid]="'view-button-' + form.id">
                  <app-icon name="eye" />
                  {{ form.name }}
                </app-button>
                }
              </div>
            </div>
            <div class="checkPoint-actions flex gap-md">
              <app-button data-testid="edit-button" variant="icon" [routerLink]="['/checkpoints', checkPoint.id]"
                [tippy]="'checkpoint.list.edit' | translate" *hasPermission="'asset.update'">
                <app-icon name="pencil" />
              </app-button>
            </div>
          </div>
        </div>
      </ng-template>
      }
    </app-card-content>
  </app-card>
</div>